<template>
  <Modal :show.sync="show">
    <!-- Contact Support Section -->
    <div class="row">
      <div class="col-12">
        <div class="contact-support-banner bg-light p-3 rounded mb-4">
          <div>
            <h5 class="fw-bold mb-3">{{ $t('contact-support') }}</h5>
            <p class="mb-3">
              {{ $t('need-help-or-have-questions') }}
              <br>
              {{ $t('submit-a-support-ticket-and-our-team-will-get-back-to-you') }}
            </p>

            <a
              href="https://support.resonancehealth.net/help/4204616749"
              target="_blank"
              rel="noopener noreferrer"
              class="btn btn-primary"
              data-test="external_support_link"
              style="padding: 0.425rem 1.2rem !important;"
            >
              {{ $t('submit-support-ticket') }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Help Center Section -->
    <div class="row mt-3">
      <div class="col-12">
        <div class="fs-6 fw-semibold mb-3">
          {{ $t('find-answers-to-commonly-asked-questions-and-access-resources-to-unlock-the-full-potential-of-networks') }}
        </div>
        <div v-for="article in articles" :key="article.title">
          <div class="d-flex mt-3" style="justify-content: space-between; align-items: center; font-size: medium;">
            <span class="fw-semibold me-2">{{ article.title }}</span>
            <div class="justify-content-end">
              <a :href="article.url" target="_blank" rel="noopener noreferrer" class="me-1 fw-bold">{{ $t('read') }}</a>
            </div>
          </div>
          <div class="separator"></div>
        </div>
      </div>
    </div>

    <!-- Training Network Section -->
    <div class="row mt-3">
      <div class="col-12">
        <div class="fs-6 fw-semibold mb-3">
          {{ $t('access-our-training-network-to-explore-relevant-videos-on-using-our-product-suite') }}
        </div>
        <div class="d-flex mt-3" style="justify-content: space-between; align-items: center; font-size: medium;">
          <span class="fw-semibold me-2">
            Resonance Training Network
          </span>
          <div class="justify-content-end">
            <a href="/networks/resonance-training" target="_blank" rel="noopener noreferrer" class="me-1 fw-bold">{{ $t('access') }}</a>
          </div>
        </div>
        <div class="separator"></div>
      </div>
    </div>
    <template #footer>
      <button id="close" data-test="close" class="btn btn-bg-light btn-sm me-2" @click="closeModal">
        {{ $t('Nav.close') }}
      </button>
    </template>
  </Modal>
</template>
<script>
import Modal from '@/components/commons/Modals/Modal.vue';

export default {
  name: 'HelpAndSupport',
  components: {
    Modal
  },
  props: {
    isShowModal: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      show: false,
      articles: [
        {
          title: this.$t('how-to-find-and-join-a-network'),
          url: 'https://support.resonancehealth.net/hc/4204616749/15/how-to-find-and-join-a-network?category_id=13',
        },
        {
          title: this.$t('how-to-search-for-media'),
          url: 'https://support.resonancehealth.net/hc/4204616749/14/how-to-search-for-media?category_id=13',
        },
        {
          title: this.$t('how-to-join-a-networks-meeting'),
          url: 'https://support.resonancehealth.net/hc/4204616749/16/how-to-join-a-network-meeting?category_id=11',
        },
        {
          title: this.$t('how-to-add-networks-meetings-to-your-calendar'),
          url: 'https://support.resonancehealth.net/hc/4204616749/17/how-to-add-network-meetings-to-your-calendar?category_id=11',
        },
      ],
    };
  },
  watch: {
    isShowModal() {
      this.show = true;
    }
  },
  methods: {
    closeModal() {
      this.show = false;
    },
  }
};
</script>
<style scoped>
.contact-support-banner {
  border: 2px solid #e3f2fd;
  background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
}
.contact-support-banner .btn-primary {
  border-color: #005f9a;
  font-weight: 600;
  padding: 12px 24px;
}
.contact-support-banner .btn-primary:hover {
  background-color: #00304e;
  border-color: #00304e;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 95, 154, 0.3);
}
.contact-support-banner .btn-outline-secondary:hover {
  transform: translateY(-1px);
}
html a:hover, html a:active, html a:focus, body a:hover, body a:active, body a:focus {
  text-decoration: none !important;
}
.separator {
  border-bottom-style: dashed;
  border-bottom-color: #dfdfdf;
  display: block;
  height: 0;
  border-bottom: 1px solid #dfdfdf;
}
</style>
